// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import { TranslationContext } from "../translation";

const IMAGES = {
	"LCC_DE": require("../assets/LCC_DE.png"),
	"LCC_EN": require("../assets/LCC_EN.png"),
	"TCO_DE": require("../assets/TCO_DE.png"),
	"TCO_EN": require("../assets/TCO_EN.png")
};

export const TcoLccImage = (props) => {
	const { type, ...others } = props;
	const { language } = useContext(TranslationContext);
	const imageName = `${type}_${language}`;

	if (!IMAGES.hasOwnProperty(imageName)) {
		return null;
	}

	return (
		<img
			src={IMAGES[imageName]}
			alt={imageName}
			{...others}
		/>
	);
};

TcoLccImage.propTypes = {
	type: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/tco/components/tcolccimage.js